import { Controller } from "@hotwired/stimulus"

// A checkbox that reveals a block of fields.
export default class extends Controller {
  static targets = ["switch", "panel"]

  connect() { this.toggle() }

  toggle() {
    const on = this.hasSwitchTarget && this.switchTarget.checked
    this.panelTargets.forEach(panel => panel.classList.toggle("hidden", !on))
  }
}
